import { render, staticRenderFns } from "./ViewAttachmentModal.vue?vue&type=template&id=2ea278ce&scoped=true"
import script from "./ViewAttachmentModal.vue?vue&type=script&lang=js"
export * from "./ViewAttachmentModal.vue?vue&type=script&lang=js"
import style0 from "./ViewAttachmentModal.vue?vue&type=style&index=0&id=2ea278ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea278ce",
  null
  
)

export default component.exports